<template>
  <div id="leftNavDrawer">
    <v-navigation-drawer
      id="navSection"
      app
      mini-variant-width="68"
      v-show="!showNavs"
      dark
      height="100%"
      v-model="drawer"
      absolute
      :temporary="temporary"
      :mini-variant="!isMaximized && !temporary"
      mobile-breakpoint="960"
      width="220"
      style="z-index: 5"
    >
      <router-link
        to="/dashboard"
        replace
      >
        <div
          class="navHeaderSmall"
          v-if="!isMaximized && !temporary"
          v-on:click="changeActiveNav('dashboard')"
          v-bind:style="{ backgroundImage: 'url(' + facilityLogoSmall + ')' }"
        />

        <div
          class="navHeaderLarge"
          v-if="isMaximized || temporary"
          v-on:click="changeActiveNav('dashboard')"
          v-bind:style="{ backgroundImage: 'url(' + facilityLogo + ')' }"
        />
      </router-link>

      <router-link
        to="/profile"
        replace
      >
        <v-avatar :class="isMaximized ? 'float-maxed' : 'float-min'">
          <img
            alt="image"
            class="img-circle-small"
            :src="profileImg"
          />
        </v-avatar>
      </router-link>
      <div
        v-if="isMaximized"
        style="display: inline-block; padding-left: 10px; color: white; user-select: none"
        class="noActive"
      >
        <router-link
          to="/profile"
          replace
        >
          {{ getUser.firstname }} {{ getUser.lastname }}
          <div style="max-width: 140px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
            {{ getUser.position }}
          </div>
        </router-link>
        <menu-role-selector @change="onMenuRoleChange" />
      </div>

      <div
        v-show="isMaximized"
        class="text-center"
        style="padding-top: 30px"
      >
        <v-menu
          offset-y
          dense
          close-on-click
          close-on-content-click
          transition="scroll-y-transition"
          origin="center center"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              color="primary"
              :loading="isLoading"
              v-bind="attrs"
              class="hidden-sm-and-down truncateFacilityName"
              >{{ getUser.facilityname }}</v-btn
            >
          </template>

          <v-list
            dense
            shaped
          >
            <v-list-item-group
              v-model="selectedFacility"
              color="primary"
            >
              <v-list-item
                v-for="facility in facilities"
                :key="facility.id"
              >
                <v-list-item-title>{{ facility.facility }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>

      <div
        style="padding: 8px 7px 8px 8px"
        v-show="isMaximized"
        v-if="isMetrcEnabled || getUser.facility.state == 'WA'"
      >
        <facility-license-selector-2
          class="hidden-sm-and-down"
          v-if="isMetrcEnabled"
        />
        <facility-license-selector-wa
          class="hidden-sm-and-down"
          v-if="getUser.facility.state == 'WA'"
        />
      </div>
      <div
        v-else
        style="height: 25px"
      />

      <!-- spacer -->

      <div
        v-if="!isMaximized"
        style="height: 50px"
      />

      <v-list v-bind:class="[isMaximized ? 'maximizedNavList' : 'minimizedNavList']">
        <div />

        <v-list-item-group v-model="selectedTopLevelItemIndex">
          <v-list-item
            v-for="(item, i) in topLevelMenuItems"
            :key="i"
            @click="activateTopLevel(item, i)"
            class="clickable"
          >
            <v-tooltip
              right
              :disabled="isMaximized"
            >
              <template v-slot:activator="{ on }">
                <v-list-item-icon v-on="on">
                  <v-icon v-text="item.class"></v-icon>
                </v-list-item-icon>
              </template>
              <span>{{ item.menuItem }}</span>
            </v-tooltip>
            <v-list-item-content>
              <v-list-item-title v-text="item.menuItem"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="hasShortMenu"
            @click="onChangeMenu"
          >
            <v-list-item-content>
              <v-list-item-title class="d-flex justify-center">
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="useShortMenu"
                      v-on="on"
                      color="white"
                      >mdi-chevron-double-down</v-icon
                    >
                    <v-icon
                      v-else
                      v-on="on"
                      color="white"
                      >mdi-chevron-double-up</v-icon
                    >
                  </template>
                  <span v-if="useShortMenu">Show More</span>
                  <span v-else>Show Less</span>
                </v-tooltip>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        <div />
      </v-list>

      <div
        class="d-flex"
        v-if="false"
      >
        <v-switch
          class="ma-0 px-2"
          dense
          flat
          hide-details
          v-model="useShortMenu"
          label="Short Menu"
          @change="onChangeMenu"
        />
      </div>
      <template v-if="getUser.facilityname.indexOf('Agrify') != 0">
        <div
          v-if="isMaximized"
          :style="largeLogo"
          class="bottom-nav-logo"
          v-show="!showNavs"
        />
        <div
          v-if="!isMaximized"
          :style="smallLogo"
          class="bottom-nav-logo"
          v-show="!showNavs"
        />
      </template>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="drawer2"
      dark
      absolute
      stateless
      class="secondary-drawer"
      :class="{ 'secondary-drawer-mini': isMiniDrawer }"
    >
      <v-list dense>
        <v-list-item
          class="secondary-menu-item"
          v-for="(item, i) in (selectedTopLevelItem && selectedTopLevelItem.children) || []"
          :key="i"
          :to="{ path: item.route }"
          @click="drawer2 = false"
        >
          <v-list-item-icon>
            <v-icon v-text="item.class"></v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-text="item.menuItem"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FacilityLicenseSelector2 from '@/components/metrc/FacilityLicenseSelector2.vue';
import FacilityLicenseSelectorWa from '@/components/statecompliance/washington/FacilityLicenseSelector.vue';
import MenuRoleSelector from './MenuRoleSelector.vue';
import Trimaster from '@/plugins/servers/trimaster.js';
import vuetifyToast from '@/vuetifyToast.js';

const DEMO_FACILITY = 'DEMO Main Facility';

export default {
  name: 'navbar',
  components: {
    FacilityLicenseSelector2,
    MenuRoleSelector,
    FacilityLicenseSelectorWa,
  },
  props: [
    'facilities',
    'facilityNavMenu',
    'showNavs',
    'changeActiveNav',
    'isMaximized',
    'facilityLogoSmall',
    'facilityLogo',
    'changeFacility',
    'mini',
    'profileImg',
    'smallLogo',
    'largeLogo',
    'userId',
  ],
  data() {
    return {
      userFacilities: [],
      simulatedMenuItems: [],
      //drawer: null,
      isMetrcEnabled: false,
      isLoading: false,
      temporary: this.$vuetify.breakpoint.smAndDown,
      facilitySelector: null,
      selectedFacility: null,
      drawer2: false,
      selectedTopLevelItem: null,
      selectedTopLevelItemIndex: null,
      useShortMenu: false,
    };
  },
  beforeMount() {
    let me = this;
    if (this.getUser.facility.isMetrcEnabled) {
      this.isMetrcEnabled = true;
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      let me = this;
      console.log(this.getUser.facility);
    },
    onMenuRoleChange(roleId) {
      let me = this;

      Trimaster.get('ag_navigationMenus/getMenuForCurrentUser', this.getUser.apitoken, {
        facility_id: this.getUser.facility_id,
        role_id: roleId,
      }).then(function ([res, err]) {
        me.simulatedMenuItems = res;
      });
    },
    activateTopLevel(item, index) {
      if (this.drawer2 && this.selectedTopLevelItem && this.selectedTopLevelItem.menuItem === item.menuItem) {
        this.drawer2 = false;
        return;
      }
      this.selectedTopLevelItemIndex = index;
      this.selectedTopLevelItem = item;
      this.drawer2 = true;
    },
    closeNavbar() {
      this.drawer2 = false;
    },
    onChangeMenu(val) {
      this.useShortMenu = !this.useShortMenu;
      // const shortMenuItems = this.facilityNavMenu.navmenu.filter(m => m.isShortMenu);
      // if (val && !shortMenuItems.length) {
      //   vuetifyToast.error("Please setup menu items.");
      // }
    },
  },
  computed: {
    ...mapGetters(['getUser', 'facilityData']),
    drawer: {
      get() {
        return this.$store.state.navigation.drawer;
      },
      set(val) {
        //this.$store.dispatch('setDrawer', val)
        this.$store.commit('SET_DRAWER', val);
      },
    },
    topLevelMenuItems() {
      return this.menuitems.filter((item) => item.children);
    },
    hasShortMenu() {
      if (this.simulatedMenuItems.length === 0) {
        if (this.facilityNavMenu && this.facilityNavMenu.navmenu) {
          let menuItems = this.temporary
            ? this.facilityNavMenu.navmenu.filter((item) => item.isMobileFriendly)
            : this.facilityNavMenu.navmenu;
          const shortMenuItems = menuItems.filter((m) => m.isShortMenu);
          return !!shortMenuItems.length;
        }
      } else {
        return false;
      }
      return false;
    },
    menuitems() {
      if (this.simulatedMenuItems.length == 0) {
        if (this.facilityNavMenu && this.facilityNavMenu.navmenu) {
          let menuItems = this.temporary
            ? this.facilityNavMenu.navmenu.filter((item) => item.isMobileFriendly)
            : this.facilityNavMenu.navmenu;

          if (this.useShortMenu) {
            const shortMenuItems = menuItems.filter((m) => m.isShortMenu);
            shortMenuItems.forEach((m) => {
              m.children = m.children.filter((c) => c.isShortMenu);
            });
            return shortMenuItems;
          }
          return menuItems;
        }
      } else {
        return this.simulatedMenuItems;
      }
      return [];
    },
    isMiniDrawer() {
      return !this.isMaximized && !this.temporary;
    },
    userIsAdmin() {
      return Trimaster.isAdmin(this.getUser);
    },
  },
  watch: {
    '$vuetify.breakpoint.smAndDown'(val) {
      this.drawer = !val;
      this.temporary = val;
    },
    selectedFacility(newVal, oldVal) {
      let fac = this.facilities[newVal];
      this.changeFacility(fac.facility_id);
    },
    drawer2(newVal) {
      this.$emit('nav-change', newVal);
    },
    facilityNavMenu: {
      handler: function (newVal) {
        if (newVal.navmenu.length && this.hasShortMenu) {
          this.useShortMenu = true;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
#leftNavDrawer {
  .v-overlay {
    display: none;
  }
  .secondary-drawer {
    z-index: 4;
    margin-left: 220px;
  }
  .secondary-drawer-mini {
    margin-left: 68px;
  }
  .secondary-drawer {
    background-color: #4f504f !important;
    .secondary-menu-item {
      color: #ffffff !important;
      background-color: #4f504f !important;
      border-bottom: 1px solid #737473;
      padding: 5px 8px !important;
    }
  }

  a {
    text-decoration: none;
    color: white;
  }
  .bottom-nav-logo {
    height: 35px;
    background-color: #363636;
    margin-bottom: 5px;
  }

  .v-list-item {
    padding: 0 8px !important;
  }
  .float-maxed {
    float: left;
    margin-left: 16px;
  }
  .float-min {
    float: left;
    margin-left: 12px;
  }
  .v-list-item__icon:first-child {
    margin-right: 3px !important;
  }
  .primary--text {
    font-weight: bold;
    color: white !important;
  }
  .v-list-group__items {
    margin-left: 5px;
  }
  .navHeaderLarge,
  .navHeaderSmall {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .navHeaderLarge {
    height: 70px;
    background-position: center center;
    background-size: contain;
  }
  .navHeaderSmall {
    height: 40px;
    background-position: center center;
    background-size: contain;
    padding: 5px;
  }
  .truncateFacilityName {
    width: 205px;
    .v-btn__content {
      display: inline-block;
      width: 190px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .v-navigation-drawer--mini-variant .v-list__tile__title {
    display: none;
  }
  #profileImg {
    display: inline-block;
    float: left;
    padding-left: 10px;
    padding-right: 10px;
  }
  .v-navigation-drawer--mini-variant #profileImg {
    float: none;
    padding: 0px;
    display: block;
    text-align: center;
  }
  .v-navigation-drawer--mini-variant .v-list__group__header .v-list__group__header__append-icon,
  .v-navigation-drawer--mini-variant .v-list__group__header .v-list__group__header__prepend-icon {
    padding: 0px !important;
  }
  .maximizedNavList {
    height: calc(100% - 340px);
    overflow: auto;
  }
  .minimizedNavList {
    height: calc(100% - 195px);
    overflow: auto;
  }
  a.router-link-exact-active.router-link-active {
    background-color: inherit !important;
  }
  .v-list-item__action {
    margin-right: 5px !important;
  }
  #navSection .v-navigation-drawer__content {
    overflow: hidden;
  }
}
</style>
